import React, { FC } from 'react';

import styles from './KeyValueList.module.scss';
import { List, ListItem } from '@mui/material';

export type KeyValue = {
  key: string;
  value: string;
};

interface KeyValueListProps {
  header: string;
  details: KeyValue[];
}

const KeyValueList: FC<KeyValueListProps> = ({header, details}) => {
  return (
    <div
      className={styles.KeyValueList}
      data-testid="KeyValueList"
    >
      <header className={styles.keyValueListHeader}>{header}</header>
      <List
        dense
        disablePadding
        className={styles.keyValueListContent}
      >
        {details &&
          details.map((detail: KeyValue, index: number) => {
            return (
              <ListItem
                key={index}
                disablePadding
                className={styles.keyValueListItem}
              >
                <div>{detail.key}:</div>
                <div>{detail.value}</div>
              </ListItem>
            )
          })
        }
      </List>
      <footer className={styles.keyValueListFooter}></footer>
    </div>
  );
}

export default KeyValueList;
